// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3211":"css/admin-app.6906","5637":"css/app.6906"}[chunkId] + ".css";
};